<template src="./FichaAfiliacion.html"></template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {Breadcrumb, BreadcrumbItem, Button, Option, Select, Autocomplete, Divider} from "element-ui";
import {FichaAfiliacionMixin} from "@/mixins/FichaAfiliacionMixin";
import {requestCoreMixin} from "@/api/coreApi";

export default {
  name: "FichaAfiliacion",
  components: {
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Autocomplete.name]: Autocomplete,
    [Divider.name]: Divider,
  },
  data: () => ({
    loading: true,
    errored: false,
    model: {
      person: '',
      listPeople: [],
      seleccionado: '',
      afiliaciones: [],
      period: '',
      listperiods: [
        {
          glosa: "Última Afiliación",
          codigo: 1
        },
        {
          glosa: "Seleccionar una Afiliación",
          codigo: 2
        },
      ]
    },
  }),
  mixins: [
    requestCoreMixin,
    ScreenSizeMixin,
    NotifyMixin,
    FichaAfiliacionMixin
  ],
}
</script>
